import React, { useEffect } from "react";

import CardSelectAppointmentDatetime from "./CardSelectAppointmentDatetime";

import { setupElementResize } from "../common/CommonInterface";
import { RehabDeviceSlotType, RehabPlanType, SelectRehabDeviceSlotType } from "./RHBInterface";

type CardSelectDateTimeRehabProps = {
  onEvent: (e: any) => any;
  setProp: (key: string, value: any, callback?: () => void) => any;
  proxyController: any;
  checkedAppointmentList: Record<string, any>[];
  rehabDeviceSlot?: RehabDeviceSlotType;
  rehabTreatmentList?: RehabPlanType[];
  selectedRehabDeviceSlot?: SelectRehabDeviceSlotType;
  buttonLoadCheck: any;
  errorMessage: any;
  languageUX: string;
  masterOptions: any;
  searchedItemListWithKey: any;
  selectedDivision: any;
  selectedPatient: any;
};

const CardSelectDateTimeRehab = (props: CardSelectDateTimeRehabProps) => {
  useEffect(() => {
    const resizer = setupElementResize({
      observerSelector: ".patient-appointment-panel",
      padding: 100,
      targetSelector: ".ReactTable.SelectAppDatetime",
    });

    resizer.initialize();

    return () => {
      resizer.disconnect();
    };
  }, []);

  const handleSuccess = async (data: { appointment: any }) => {
    const [result] = await props.onEvent({
      message: "RefreshAppointment",
      params: { noGetWaiting: true },
    });

    const items: any[] = result?.items || [];

    const appointment = items.find((item) => item.id === data.appointment.id);

    if (appointment) {
      props.onEvent({ message: "SelectAppointment" as any, params: { ...appointment } });
    }
  };

  return (
    <CardSelectAppointmentDatetime
      onEvent={props.onEvent}
      setProp={props.setProp}
      proxyController={props.proxyController}
      checkedAppointmentList={props.checkedAppointmentList}
      columnWidth={107.25}
      divisionId={props.selectedDivision?.id}
      fixedColumnWidth={185}
      rehabDeviceSlot={props.rehabDeviceSlot}
      rehabTreatmentList={props.rehabTreatmentList}
      selectedRehabDeviceSlot={props.selectedRehabDeviceSlot}
      tableStyle={{ width: "calc(100vw - 35.5rem)" }}
      hideCombine
      hideCreateNew
      hideHeader
      showSelectDivision
      buttonLoadCheck={props.buttonLoadCheck}
      errorMessage={props.errorMessage}
      languageUX={props.languageUX}
      searchedItemListWithKey={props.searchedItemListWithKey}
      selectedPatient={props.selectedPatient}
      divisionOptions={props.masterOptions?.division}
      onSuccess={handleSuccess}
    />
  );
};

CardSelectDateTimeRehab.displayName = "CardSelectDateTimeRehab";

export default React.memo(CardSelectDateTimeRehab);
